// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1Xp6H","title":"ClientReferral_title__25rEn","itemText":"ClientReferral_itemText__3qTnU"};